 <template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>参数类型配置</h4>
          <el-button type="primary" class="adduser" @click="handleAdd"
            >添加</el-button
          >
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="参数名称：">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入参数名称"
              maxlength="50"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="参数名称">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          :title="addEditTitle"
          :visible.sync="addEditIsDialog"
          :before-close="handleCancel"
          width="600px"
          center
          style="z-index: 10000"
        >
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="参数名称：" prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入参数名称"
                    maxlength="50"
                    show-word-limit
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        name: "",
      },
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: "",
        name: "",
      },
      rules: {
        // 添加、编辑弹窗表单规则
        name: [
          {
            required: true,
            message: "请输入参数名称",
            trigger: "blur",
          },
        ],
      },
      addEditTitle: "添加参数类型", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
    };
  },
  created() {
    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        name: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.homeParam.getHomeParamList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.count;
        }
      });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.homeParam.delHomeParam(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑参数类型";
      this.ruleForm.id = row.id;

      // 获取详情
      this.$api.homeParam.getHomeParam({ id: row.id }).then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data;
        }
      });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加参数类型";
      this.ruleForm.id = "";
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.ruleForm.pushMode = this.ruleForm.pushModeArr
            ? this.ruleForm.pushModeArr.toString()
            : "";
          this.$api.homeParam.saveHomeParam(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.handleCancel();
              this.handleSearch();
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>